import React, { useEffect, useState } from "react";
const NewCoinSingleItem = ({ data }) => {
    const [livePrice, setLivePrice] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const interval = setInterval(() => {
            fetchData();
        }, 1000);
        return () => clearInterval(interval);
    }, [livePrice, data]);

    const fetchData = async () => {
        if (data?.symbol) {
            fetch(
                `https://new-coin-api.wlffinance.org/api/user/new/coin/price/live/view/${data?._id}?period=1m`,
                {
                    method: "GET",
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    setLivePrice(data.data);
                    if (data.data) {
                        setLivePrice(data?.data);
                        setLoading(false);
                    }
                });
        }
    };
    if (loading) {
        return;
    }
    return (
        <>
            <div className="row popular-market-list">
                <div className="col-6">
                    <h6>
                        {data?.name}
                    </h6>
                </div>
                <div className="col-6 ">
                    <div className="row popular-market-list-right">
                        <div className="col-6 ">
                            <h6>
                                ${livePrice?.close}
                            </h6>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NewCoinSingleItem;
